import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { appendLeadingZeros } from '@app/core/helpers';
import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { Subscription, timer } from 'rxjs';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { CampaignService } from './campaign.service';
import { LayoutService } from './layout.service';
import { VisibilityService } from './visibility.service';

@Injectable()
export class CallService implements OnDestroy {
  callTimerSubscription!: Subscription;
  stringTimer: any = '00:00:00';
  callDuration: number = 0;
  subscription = new Subscription();
  callInProgress: boolean = false;
  constructor(
    private http: HttpClient,
    public telephony: TelephonyProvider,
    private visibiltyService: VisibilityService
  ) {
    this.subscription.add(
      this.telephony.voice.events.subscribe((event) => {
        switch (event.type) {
          case 'Call':
            switch (event.name) {
              case 'accept':
                this.callDuration = 0;
                window.localStorage.setItem('call_time', moment().toString());
                this.callInProgress = true;
                this.startCallTimer();
                break;
              case 'cancel':
              case 'dispose':
              case 'disconnect':
                window.localStorage.removeItem('call_time');
                this.callInProgress = false;
                this.endCallTimer();
                break;
            }
            break;
        }
      })
    );
    this.subscription.add(
      this.visibiltyService.visibilityChange.subscribe((e: any) => {
        if (e.target.hidden) {
          if (this.callInProgress) {
            this.endCallTimer();
          }
        } else {
          if (this.callInProgress) {
            this.startCallTimer();
          }
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  endCallTimer() {
    if (this.callTimerSubscription) {
      this.callTimerSubscription.unsubscribe();
    }
  }
  startCallTimer() {
    if (this.callTimerSubscription) {
      this.endCallTimer();
    }
    let hour: any = 0;
    let sec: any = 0;
    let min: any = 0;

    const call_time = window.localStorage.getItem('call_time');
    if (call_time && this.callInProgress) {
      const date = moment(new Date(call_time));
      const now = moment();
      hour = now.diff(date, 'hours') % 60;
      min = now.diff(date, 'minutes') % 60;
      sec = now.diff(date, 'seconds') % 60;
      if (sec >= 60) {
        min += 1;
        sec = 0;
        if (min == 60) {
          min = 0;
          sec = 0;
          hour += 1;
        }
      }
      this.callDuration = now.diff(date, 'seconds');
    }
    this.stringTimer = '00:00:00';
    this.callTimerSubscription = timer(0, 1000).subscribe((x: number) => {
      this.callDuration++;
      sec += 1;
      if (sec == 60) {
        min += 1;
        sec = 0;
        if (min == 60) {
          min = 0;
          sec = 0;
          hour += 1;
        }
      }
      this.stringTimer = appendLeadingZeros(hour) + ':' + appendLeadingZeros(min) + ':' + appendLeadingZeros(sec);
    });
  }
  hangup() {
    this.telephony.voice.endCall(null);
  }
}
